import { RagSource } from "../api/ragApi";

interface RagSourceChipProps {
  source: RagSource;
}

const RagSourceChip = ({ source }: RagSourceChipProps) => {
  return (
    <div
      className="inline-flex items-center gap-1 px-2 py-1 rounded bg-gray-100 text-xs text-gray-600 hover:bg-gray-200 transition-colors cursor-default"
      title={source.preview}
    >
      <span className="text-gray-400">📄</span>
      <span>{source.filename}</span>
    </div>
  );
};

export default RagSourceChip;
